module.exports = __webpack_public_path__ + "img/1521150855.4ac1c2b5.jpg";